export const PERMISSION_RESOURCE_CODES = {
  dashboard: 'reimbursement-dashboard',
  invoicesMy: 'reimbursement-invoices-my',
  invoicesAll: 'reimbursement-invoices-all',
  claimsMy: 'reimbursement-claims-my',
  claimsAll: 'reimbursement-claims-all',
  approval: 'reimbursement-approval',
  myAnalytics: 'reimbursement-my-analytics',
  managementCockpit: 'reimbursement-management-cockpit',
  specialAnalytics: 'reimbursement-special-analytics',
  settingsReimbursement: 'settings-reimbursement',
  anomalyRules: 'settings-anomaly-rules',
  expenseCategories: 'settings-expense-categories',
  sceneTemplates: 'settings-scene-templates',
  expenseStandardPolicies: 'settings-expense-standard-policies',
  personalQuotaConfigs: 'settings-personal-quota-configs',
  permissions: 'settings-permissions',
} as const;

export const PERMISSION_ACTION_CODES = {
  dashboard: {
    view: 'view',
    viewOverview: 'view-overview',
    viewQuickActions: 'view-quick-actions',
    viewRecentClaims: 'view-recent-claims',
    viewMyTrend: 'view-my-trend',
    viewApprovalTodos: 'view-approval-todos',
    viewRiskReminders: 'view-risk-reminders',
  },
  invoicesMy: {
    view: 'view',
    create: 'create',
    edit: 'edit',
    delete: 'delete',
  },
  invoicesAll: {
    view: 'view',
    delete: 'delete',
  },
  claimsMy: {
    view: 'view',
    create: 'create',
    edit: 'edit',
    delete: 'delete',
    submit: 'submit',
    withdraw: 'withdraw',
    syncWorkflow: 'sync-workflow',
  },
  claimsAll: {
    view: 'view',
    delete: 'delete',
  },
  approval: {
    view: 'view',
  },
  myAnalytics: {
    view: 'view',
  },
  managementCockpit: {
    view: 'view',
  },
  specialAnalytics: {
    view: 'view',
  },
  settingsReimbursement: {
    view: 'view',
    manage: 'manage',
  },
  anomalyRules: {
    view: 'view',
    create: 'create',
    edit: 'edit',
    delete: 'delete',
    enable: 'enable',
    disable: 'disable',
  },
  expenseCategories: {
    view: 'view',
    create: 'create',
    edit: 'edit',
    enable: 'enable',
    disable: 'disable',
  },
  sceneTemplates: {
    view: 'view',
    create: 'create',
    edit: 'edit',
    enable: 'enable',
    disable: 'disable',
  },
  expenseStandardPolicies: {
    view: 'view',
    create: 'create',
    edit: 'edit',
    enable: 'enable',
    disable: 'disable',
  },
  personalQuotaConfigs: {
    view: 'view',
    create: 'create',
    edit: 'edit',
    enable: 'enable',
    disable: 'disable',
  },
  permissions: {
    view: 'view',
  },
} as const;
